import React from 'react';
import IconProps from '../../icons';

const KitLogo = ({ width = 32, className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      className={className}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_18390_214185)'>
        <mask
          id='mask0_18390_214185'
          maskUnits='userSpaceOnUse'
          x='4'
          y='10'
          width='24'
          height='11'
        >
          <path
            d='M27.9773 10H4V21H27.9773V10Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_18390_214185)'>
          <mask
            id='mask1_18390_214185'
            maskUnits='userSpaceOnUse'
            x='4'
            y='10'
            width='24'
            height='11'
          >
            <path
              d='M27.9878 10H4.00098V21H27.9878V10Z'
              fill='white'
            />
          </mask>
          <g mask='url(#mask1_18390_214185)'>
            <path
              d='M10.5709 14.5772C13.5225 15.1575 14.4387 17.933 14.4628 20.7246C14.4634 20.7874 14.4134 20.8386 14.3516 20.8386H10.6361C10.5748 20.8386 10.5249 20.7884 10.5245 20.726C10.5134 18.5602 10.1679 16.649 8.05524 16.5664C7.99221 16.564 7.93969 16.6153 7.93969 16.6794V20.7257C7.93969 20.788 7.88988 20.8386 7.82847 20.8386H4.11219C4.05079 20.8386 4.00098 20.7882 4.00098 20.7257V10.4157C4.00098 10.3533 4.05079 10.3027 4.11219 10.3027H7.82847C7.88988 10.3027 7.93969 10.3533 7.93969 10.4157V14.2778C7.93969 14.3351 7.98539 14.3815 8.04181 14.3815C8.08653 14.3815 8.12628 14.3519 8.13927 14.3084C9.09656 11.1235 10.8844 10.3227 13.7875 10.3031C13.8491 10.3026 13.8996 10.3534 13.8996 10.416V14.2686C13.8996 14.3309 13.8498 14.3815 13.7884 14.3815H10.5895C10.5358 14.3815 10.4922 14.4257 10.4922 14.4803C10.4922 14.5276 10.5253 14.5683 10.5709 14.5772ZM20.7448 16.9915V14.4945C20.7448 14.4321 20.7946 14.3815 20.856 14.3815H23.5907C23.6445 14.3815 23.6881 14.3372 23.6881 14.2825C23.6881 14.2351 23.6549 14.1945 23.6091 14.1854C21.4694 13.7543 20.4817 12.5032 20.4476 10.4158C20.4466 10.3538 20.4957 10.3027 20.5566 10.3027H24.5723C24.6337 10.3027 24.6835 10.3533 24.6835 10.4157V12.1742C24.6835 12.2365 24.7333 12.2871 24.7947 12.2871H27.0972C27.1586 12.2871 27.2084 12.3377 27.2084 12.4001V14.2686C27.2084 14.3309 27.1586 14.3815 27.0972 14.3815H24.7947C24.7333 14.3815 24.6835 14.4321 24.6835 14.4945V16.5086C24.6835 17.2202 25.113 17.4548 25.6841 17.4548C26.5791 17.4548 27.462 17.0452 27.8161 16.8595C27.8902 16.8207 27.9783 16.8753 27.9783 16.9599V20.0954C27.9783 20.1791 27.9328 20.2561 27.8598 20.2951C27.5102 20.4819 26.4295 20.9998 25.1931 20.9998C22.6504 21 20.7448 19.9471 20.7448 16.9915ZM15.5175 20.7257V14.4943C15.5175 14.4319 15.5673 14.3813 15.6287 14.3813H19.345C19.4064 14.3813 19.4562 14.4319 19.4562 14.4943V20.7257C19.4562 20.788 19.4064 20.8386 19.345 20.8386H15.6287C15.5673 20.8386 15.5175 20.7882 15.5175 20.7257ZM15.307 11.9205C15.307 12.9811 16.0444 13.841 17.4611 13.841C18.8778 13.841 19.6152 12.9811 19.6152 11.9205C19.6152 10.8599 18.8777 10 17.4611 10C16.0444 10 15.307 10.8599 15.307 11.9205Z'
              fill='#1E1E1E'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_18390_214185'>
          <rect
            width='24'
            height='11'
            fill='white'
            transform='translate(4 10)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KitLogo;
